module.exports = new __parcel__URL__("createViewLight.260d0208.svg").toString();